import { render, staticRenderFns } from "./ModuleInputBlock.vue?vue&type=template&id=d447eba0&scoped=true"
import script from "./ModuleInputBlock.vue?vue&type=script&lang=js"
export * from "./ModuleInputBlock.vue?vue&type=script&lang=js"
import style0 from "./ModuleInputBlock.vue?vue&type=style&index=0&id=d447eba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d447eba0",
  null
  
)

export default component.exports